import { type Translation, createTranslation } from 'models';
import { useMutation } from 'query';
import { getTranslate } from '../../services';

export type TranslateMutationData = {
  id: string;
  language?: string;
  type: string;
};

export const useGetTranslateMutation = () =>
  useMutation<Translation, TranslateMutationData>({
    async mutationFn(params) {
      const response = await getTranslate({
        body: {
          translation: params,
        },
      });
      return createTranslation(response.data);
    },
  });
